// Shared copy for the out-of-sync recovery UI, used by both the in-page
// OutOfSyncModal and the top-level ErrorBoundary fallback.
export const OUT_OF_SYNC_TITLE = "Out of sync";
export const OUT_OF_SYNC_MESSAGE =
  "A new version of Indigo Portal has been released, so this tab is now out of date. Some features won't load until you reload. Save any unsaved work first, then reload to get the latest version.";
